<template>
  <base-slide-over ref="slideover" title="Invite Team Member" size="lg" style="z-index: 10000">
    <base-form class="tw-py-2.5 tw-px-4 sm:tw-py-4 sm:tw-px-6" v-model="isFormValid" ref="form" @submit.prevent>
      <base-text-field label="Name" placeholder="Enter user's first and last name" v-model="name" class="tw-mt-3" required :maxLength="255" />
      <base-email-field label="Email" placeholder="Enter email address" v-model="email" :readonly="isLoading" required />
      <div class="tw-mt-2 tw-mb-1">Roles</div>
      <base-radio-group :value="selectedRole" class="tw-space-y-1" required>
        <base-radio value="business_administrator" name="role" v-model="selectedRole">Administrator</base-radio>
        <base-radio value="business_management" name="role" v-model="selectedRole">Management</base-radio>
        <base-radio value="business_operations" name="role" v-model="selectedRole">Operations</base-radio>
      </base-radio-group>
      <!-- Secondary Role select -->
      <base-select
        class="tw-mt-4"
        v-if="cobrandId === 'rx-harmony' && selectedRole === 'business_management'"
        label="Secondary Role (optional)"
        :options="secondaryRoleOptions"
        v-model="secondaryRole"
        placeholder="Select secondary role"
        valueKey="value"
        labelKey="text"
      />
      <div class="tw-flex tw-my-4">
        <div class="tw-text-sm tw-mr-2 tw-my-auto tw-text-gray-800 tw-cursor-pointer">All Locations</div>
        <base-toggle v-model="isAllLocations" :disabled="isLocationFiltered === true" />
      </div>
      <div class="tw-my-6" v-show="!isAllLocations">
        <base-advanced-select
          ref="locationsSelect"
          label="Locations"
          placeholder="Select one or more locations"
          :options="locations"
          v-model="selectedLocations"
          label-key="name"
          multiple
          :required="!isAllLocations"
        />
        <div class="tw-text-xs tw-mt-2 tw-text-gray-500">
          Please select location(s) in order to proceed. If you want to give access to all locations, please toggle on "All Locations" option.
        </div>
      </div>
      <!-- <base-text-field label="NPI" placeholder="Enter user's NPI" v-model="npi" class="tw-mt-4" :maxlength="50" />
      <base-text-field label="DEA" placeholder="Enter user's DEA" v-model="dea" class="tw-mt-5" :maxlength="50" /> -->
    </base-form>
    <template #fixed-bottom>
      <div class="tw-py-2 tw-px-3 tw-flex tw-justify-end">
        <base-button type="flat" class="tw-w-auto tw-mr-3" @click="close">
          Cancel
        </base-button>
        <base-button :loading="isLoading" :disabled="!isFormValid" class="tw-w-auto" @click="submit">
          Send
        </base-button>
      </div>
    </template>
  </base-slide-over>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "BusinessUserInviteSlideover",
  components: {},
  props: {
    businessId: String,
  },
  data() {
    return {
      isLoading: false,
      isFormValid: true,
      email: null,
      selectedRole: null,
      name: null,
      npi: null,
      dea: null,
      isAllLocations: false,
      selectedLocations: [],
      secondaryRole: null,
    };
  },
  computed: {
    ...mapGetters("location", ["locations"]),
    ...mapGetters("role", ["isLocationFiltered"]),
    ...mapGetters("organization", ["cobrandId"]),
    secondaryRoleOptions() {
      return [{ value: "psc", text: "PSC" }];
    },
  },
  watch: {
    isAllLocations(newValue) {
      if (newValue === true) {
        this.$refs.locationsSelect.reset();
      }
    },
  },
  methods: {
    reset() {
      this.isLoading = false;
      this.email = null;
      this.selectedRole = null;
      this.name = null;
      this.npi = null;
      this.dea = null;
      this.isAllLocations = false;
      this.selectedLocations = [];
      this.secondaryRole = null;
      if (this.isLocationFiltered === true) {
        this.isAllLocations = false;
      }
      this.$refs.form.reset();
    },
    show() {
      this.reset();
      this.$refs.slideover.show();
    },
    submit() {
      if (!this.$refs.form.validate()) return;
      this.isLoading = true;

      if (this.selectedLocations.length > 0) {
        var locationStrings = this.selectedLocations.map(function(location) {
          return location["businessLocationId"];
        });
      }

      if (this.selectedRole !== "business_management") {
        this.secondaryRole = null;
      }

      this.$axios
        .post(`/businesses/${this.businessId}/user-invites`, {
          name: this.name,
          email: this.email,
          roles: [this.selectedRole],
          locations: this.isAllLocations ? [] : locationStrings,
          npi: this.npi,
          dea: this.dea,
          secondaryRole: this.secondaryRole || null,
        })
        .then(() => {
          this.isLoading = false;
          this.close();
          this.EventBus.$emit("GLOBAL_NOTIFY", { title: "Invitation Sent", message: "Your invitation was sent successfully" });
          this.EventBus.$emit("business_user_invite_sent");
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    close() {
      this.$refs.slideover.hide();
      this.$emit("close");
    },
  },
};
</script>
